import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/insurance/add-white.png'
import _imports_1 from '@/assets/img/insurance/reduce-white.png'


const _withScopeId = n => (_pushScopeId("data-v-31299b0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "form-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "保险：", -1))
const _hoisted_4 = { class: "form-value" }
const _hoisted_5 = { class: "form-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "状态：", -1))
const _hoisted_7 = { class: "form-value" }
const _hoisted_8 = {
  key: 0,
  class: "label green"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("加保 ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "label red"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("减保 ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "form-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "人数：", -1))
const _hoisted_18 = { class: "form-value" }
const _hoisted_19 = { style: {"font-size":"18px","font-weight":"bold"} }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("人 ")
const _hoisted_21 = {
  key: 0,
  class: "form-row"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "金额：", -1))
const _hoisted_23 = { class: "form-value" }
const _hoisted_24 = { style: {"font-size":"18px","font-weight":"bold"} }
const _hoisted_25 = { class: "form-row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "日期：", -1))
const _hoisted_27 = { class: "form-value" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "yd" }, " 特别约定：1、仅承保视频中的对应风险等级工种，其它工种请再提供视频确认2、超风险投保警示:严格按照实际工种对应风险等线进行投保，严禁超风险投保，否则保险公司有权拒赔。如将4类及以上工种投保至1-3类工种属于超风险投保工种 ", -1))
const _hoisted_30 = { class: "form-row" }
const _hoisted_31 = { class: "alert-bottom" }
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_alert_box = _resolveComponent("alert-box")!
  const _component_plan_rule = _resolveComponent("plan-rule")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_alert_box, {
      class: "alert-form",
      onClose: _ctx.cancel,
      width: "500px",
      dataTitle: "确认提交"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.name), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (_ctx.type == 'add')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.count), 1),
              _hoisted_20
            ])
          ]),
          (_ctx.isMonth && _ctx.type === 'add')
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.money), 1),
                  _createTextVNode("元（新增" + _toDisplayString(_ctx.addCount) + "人） ", 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.date) + " 生效", 1)
          ]),
          (_ctx.hasAppFeature('addPlanAgreement') && _ctx.type === 'add')
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_el_checkbox, {
                    modelValue: _ctx.active,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.active) = $event)),
                    size: "large"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", {
                    class: "tips",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.active=!_ctx.active))
                  }, "我已阅读并同意"),
                  _createElementVNode("span", {
                    style: {"color":"#1A90F5","cursor":"pointer"},
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPlanRule = true))
                  }, "《方案条款》")
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("button", {
            class: "mini-btn white",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
          }, "取消"),
          _createElementVNode("button", {
            class: "mini-btn blue",
            disabled: _ctx.disabled,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, "确定", 8, _hoisted_32)
        ])
      ]),
      _: 1
    }, 8, ["onClose"]),
    (_ctx.showPlanRule)
      ? (_openBlock(), _createBlock(_component_alert_box, {
          key: 0,
          dataTitle: "方案条款",
          width: "600px",
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showPlanRule= false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_plan_rule, {
              rule: _ctx.rule,
              onClose: _cache[5] || (_cache[5] = ($event: any) => {_ctx.showPlanRule= false; _ctx.active=true})
            }, null, 8, ["rule"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}